export default "{\n    \"label\": \"Estado de disputa\",\n    \"options\": {\n        \"true\": \"Disputado\",\n        \"false\": \"No disputado\"\n    }\n}\n"